export const OptionalIndicator = ({ text }) => (
	<span className="text-grey">{text}</span>
);
